var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTxtBtnArrow = function SvgIconTxtBtnArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "text-arrow-circle",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#252525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "text-arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5222 8.375L9.34444 10.475L9.88889 11L13 8L9.88889 5L9.34444 5.525L11.5222 7.625L3 7.625V8.375L11.5222 8.375Z",
    fill: "white"
  })));
};
export default SvgIconTxtBtnArrow;